export const chart = [
    ['G', 'B', 'G', 'B', 'B', 'B', 'B', 'B', 'B', 'B', 'B', 'B'],
    ['B', 'G', 'B', 'G', 'G', 'B', 'B', 'B', 'B', 'B', 'G', 'G'],
    ['G', 'B', 'G', 'B', 'B', 'B', 'B', 'B', 'B', 'G', 'B', 'B'],
    ['B', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'G'],
    ['G', 'B', 'B', 'G', 'B', 'G', 'G', 'B', 'G', 'G', 'G', 'G'],
    ['B', 'B', 'G', 'B', 'B', 'G', 'B', 'G', 'B', 'B', 'B', 'G'],
    ['B', 'G', 'B', 'B', 'G', 'B', 'B', 'G', 'G', 'G', 'G', 'G'],
    ['G', 'B', 'B', 'G', 'G', 'B', 'G', 'B', 'B', 'B', 'B', 'B'],
    ['B', 'G', 'B', 'G', 'G', 'B', 'G', 'B', 'G', 'G', 'G', 'G'],
    ['G', 'B', 'G', 'B', 'G', 'G', 'B', 'B', 'B', 'B', 'G', 'B'],
    ['B', 'G', 'B', 'G', 'G', 'G', 'B', 'B', 'B', 'B', 'G', 'G'],
    ['G', 'B', 'G', 'G', 'B', 'B', 'B', 'B', 'B', 'G', 'G', 'G'],
    ['B', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'B', 'B'],
    ['B', 'G', 'B', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'B'],
    ['B', 'G', 'B', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'B'],
    ['G', 'B', 'G', 'B', 'G', 'G', 'G', 'B', 'G', 'G', 'G', 'B'],
    ['B', 'G', 'B', 'G', 'G', 'G', 'G', 'G', 'G', 'G', 'B', 'B'],
    ['B', 'B', 'G', 'B', 'G', 'G', 'G', 'B', 'G', 'G', 'B', 'B'],
    ['G', 'B', 'B', 'G', 'B', 'G', 'G', 'G', 'B', 'B', 'B', 'B'],
    ['B', 'G', 'B', 'B', 'G', 'B', 'G', 'B', 'G', 'B', 'G', 'G'],
    ['G', 'B', 'G', 'B', 'B', 'G', 'B', 'G', 'B', 'G', 'B', 'G'],
    ['B', 'G', 'B', 'B', 'B', 'G', 'G', 'B', 'G', 'B', 'G', 'G'],
    ['G', 'B', 'G', 'B', 'G', 'B', 'G', 'G', 'B', 'G', 'B', 'G'],
    ['B', 'G', 'B', 'G', 'B', 'G', 'B', 'B', 'G', 'B', 'G', 'B'],
    ['G', 'B', 'G', 'B', 'G', 'B', 'G', 'B', 'B', 'G', 'B', 'G'],
    ['B', 'G', 'B', 'G', 'B', 'G', 'B', 'G', 'B', 'B', 'B', 'B'],
    ['B', 'B', 'G', 'B', 'B', 'B', 'G', 'B', 'G', 'B', 'G', 'G'],
    ['G', 'B', 'B', 'G', 'G', 'G', 'B', 'G', 'B', 'G', 'B', 'B']
]